import { faSignalStream } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreateLiveStreamForm } from '~/components/forms/LiveStreamForm';
import { useNavigate } from '~/components/utils/Navigation';
import { Breadcrumbs } from '../molecules/Breadcrumbs';
import { Heading } from '../molecules/Heading';
import { AppBreadcrumbs } from '../organisms/Breadcrumbs';

export type IAppCreateLiveStreamPageProps = {
  appId: string;
};

export const AppCreateLiveStreamPage: React.FC<
  IAppCreateLiveStreamPageProps
> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const parentUrl = `/apps/${appId}/liveStreams`;

  return (
    <>
      <Helmet>
        <title>{t('AppCreateLiveStreamPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={`/apps/${appId}/liveStreams`}>
          <FontAwesomeIcon icon={faSignalStream} />
          {t('AppLiveStreamsPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        title={t('AppCreateLiveStreamPage.title')}
        previousUrl={parentUrl}
      />

      <CreateLiveStreamForm
        appId={appId}
        onSuccess={(createdLiveStream) =>
          navigate(`/apps/${appId}/liveStreams/${createdLiveStream._id}`)
        }
        cancelUrl={parentUrl}
      />
    </>
  );
};
